
import { format } from 'timeago.js';

  
  export default  {
      
    data(){
        return{
          tableData:[],
          pageNo:1,
          pageSize:10,
          form:{},
          enable:false,
          secondData:[],
          dialogVisible: false,
          dialogTitle:'',
          limitCount:1,
          productAttrCate:{
            name:'',
            id:'',
            code:'',
            image:''
          },  
          rules: {
            name: [
              { required: true, message: '请输入类型名称', trigger: 'blur' }
            ]
          },
          settleType:1,

          dialogImageUrl: '',
				  fileList: [],
				  objClass: {
					  upLoadShow: true,
					  upLoadHide: false,
				  },
          upLoadFile:{}
        }
    },

    methods:{

        handleChange(file:any, fileList:any) {

          this.objClass.upLoadHide = true;//上传图片后置upLoadHide为真，隐藏上传框
          this.objClass.upLoadShow = false;

          this.uploadFile = file.raw;

          console.log('改版嘎巴宝贝宝贝宝贝宝贝宝贝宝贝');
        },
        handleRemove(file:any, fileList:any) {
          this.objClass.upLoadShow = true;//删除图片后显示上传框
          this.objClass.upLoadHide = false;
        },
        // 点击预览图的放大按钮后会触发handlePictureCardPreview
        handlePictureCardPreview(file:any) {
          this.dialogImageUrl = file.url;
        },
        addImage(index:any,row:any){
            // 点击查看大图
            console.log(row);
        },
        pagedTableData() {

            return this.tableData.filter((v, i) =>

              i >= (this.pageNo - 1) * this.pageSize &&
              i <= this.pageNo * this.pageSize - 1
            );
        },
        getAttrList(index:any, row:any) {
      
            this.$router.push({path: '/MyStore/commonGoodsSecondClass',query:{cid:row.ptId,cname:row.ptName,parentCode:row.ptCode}})
        },
  
        handleSizeChange(val: number) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.pageNo = 1;
        },
  
        handleCurrentChange(val: number) {
            console.log(`当前页: ${val}`);
            this.pageNo = val;
        },
  
        onSubmit() {
            console.log(this.form);
        },
        addSubmit() {
        
          // 新增品类
          this.productAttrCate.name = '';
          this.settleType = 1;
          this.dialogVisible = true;
          this.dialogTitle = "新增类型";

          // 显示上传图片框
          this.objClass.upLoadHide = false;//上传图片后置upLoadHide为真，隐藏上传框
          this.objClass.upLoadShow = true;
        },
        handleClose() {
      
            this.dialogVisible = false;
            this.fileList = [];
            this.productAttrCate.name = '';
        },
        handleUpdateClass(index:any, row:any){
          
          // 编辑品类
          this.settleType = 2;
          this.dialogVisible = true;
          this.dialogTitle = "编辑类型";
          this.productAttrCate.name = row.ptName;
          this.productAttrCate.id = row.ptId;
          this.productAttrCate.code = row.ptCode;
          this.fileList.push({
                name: 'img.jpg',
                url: row.ptImage,
                uid: row.ptId
          });

          // 隐藏上传图片框
          this.objClass.upLoadHide = true;//上传图片后置upLoadHide为真，隐藏上传框
          this.objClass.upLoadShow = false;
        },
        handleDelete(index:any, row:any){
            // 删除类型
            
          let ptCodeList = [];
          ptCodeList.push(row.ptCode);

          this.$http.post("productType/delete",ptCodeList).then((res: any) =>{
          
              this.$confirm('删除成功');
              this.dialogVisible = false;
              this.fileList = [];
              window.location.reload();
          });
        },
        cancelUpload(){

          // 取消上传
          this.dialogVisible = false;
          this.fileList = [];
          this.productAttrCate.name = '';
        },
        sureSubmit(value:any){
            
          // 确认上传
          let settleType = value; //settleType：1 表示新增品类，2表示编辑评论
          this.fileList = [];
          var formData = new FormData();
          formData.append('file',this.uploadFile);
          
          if(settleType == 1) {
              
              // 新增品类
              formData.append('ptLevel','1');
              formData.append('ptName',this.productAttrCate.name);
              formData.append('parentCode','0');
              formData.append('ptSort','0');
    
              this.$http.post("productType",formData,{
                headers: {
                        'Content-Type': 'multipart/form-data'
                    }
              }).then((res: any) =>{
                  
                  this.dialogVisible = false;
                  window.location.reload();
              });
              
          } else  {
              // 编辑品类
              formData.append('ptLevel','1');
              formData.append('ptName',this.productAttrCate.name);
              formData.append('ptCode',this.productAttrCate.code);
              this.$http.put("productType", formData).then((res: any) =>{
                  
                    this.dialogVisible = false;
                      this.$confirm('修改成功');
                    window.location.reload();
                    this.tableData = res.data.data.data;
              });
          }
            
        },
        userStateChange(item:any){
            
            // 是否开启类型
            var itemTemp = item;
            console.log('===',itemTemp);
            this.$http.put("productType/enable?ptCode="+itemTemp.ptCode).then((res: any) =>{
			  	
					    let data = res.data;
              if(data.code == 200) {
                
                this.$confirm(data.msg);
              }
            });   
        }
    },
  
    mounted() {


      let datas = [];
      let paramter = {
          'pageNum':1,
          'pageSize':10000,
          'ptLevel':1
      };
      this.$http.get('productType/list',{params:paramter},{
          emulateJSON:true }).then((result:any) =>{
              datas = result.data.data.data;
              this.tableData = datas;
              this.tableData = this.tableData.map(item =>{
                  
                item.enable = true;
                
                return item;
              });
      })
    }
  }
  